export default [
  {
    path: 'company-primary-area-of-construction',
    meta: {
      title: 'Company > Division',
      auth: ['Admin', 'Super Admin'],
      hidden: true
    },
    component: () => import('./pages/index'),
    redirect: 'company-primary-area-of-construction/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'companyPrimaryAreaOfConstruction',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'companyPrimaryAreaOfConstruction',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'companyPrimaryAreaOfConstruction',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
